import { z } from 'zod';
import { bulkCreateSections } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  section_key: z.string().min(1, 'Section key is required'),
  parent_section_key: z.string().optional().default(''),
  order: z.string().optional().default('0'),
  isBase: z.string().optional().default('false'),
  isTypeSpecific: z.string().optional().default('false'),
  label_en: z.string().min(1, 'English label is required'),
  description_en: z.string().optional().default(''),
});

export const sectionConfig: CsvEntityConfig = {
  entityName: 'Sections',
  entityNameSingular: 'Section',
  columns: [
    { key: 'section_key', label: 'Section Key', required: true, description: 'Unique section identifier', exampleValue: 'events' },
    { key: 'parent_section_key', label: 'Parent Key', required: false, description: 'Key of parent section', exampleValue: '' },
    { key: 'order', label: 'Order', required: false, description: 'Sort order (default: 0)', exampleValue: '1' },
    { key: 'isBase', label: 'Is Base', required: false, description: 'true/false - base section for all orgs', exampleValue: 'true' },
    { key: 'isTypeSpecific', label: 'Is Type Specific', required: false, description: 'true/false - type-specific section', exampleValue: 'false' },
    { key: 'label_en', label: 'Label (EN)', required: true, description: 'English display name', exampleValue: 'Events' },
    { key: 'description_en', label: 'Description (EN)', required: false, description: 'English description', exampleValue: 'Community events section' },
  ],
  validationSchema,
  exampleRows: [
    { section_key: 'events', parent_section_key: '', order: '1', isBase: 'true', isTypeSpecific: 'false', label_en: 'Events', description_en: 'Community events section' },
    { section_key: 'announcements', parent_section_key: '', order: '2', isBase: 'true', isTypeSpecific: 'false', label_en: 'Announcements', description_en: 'Community announcements' },
  ],
  bulkCreateAction: bulkCreateSections as any,
  importNotes: [
    'Parent Section Key must reference an existing section or one created earlier in the same file.',
    'English label (label_en) is used as the primary translation.',
  ],
};



